<template>
  <!-- <v-card> -->
    <!-- <template> -->
	<div>
	    <v-row>
        <v-col lg="5">
          <s-crud
              :config="configParDis"
              title="Parámetros de Distribución"
              :filter="filterParDis"
              add
              edit
              remove
              @save="save($event)"
              @rowSelected="rowSelected($event)"
          >
              <template v-slot:filter>
                  <v-container>
                      <v-row>                        
                          <v-col>
                              <s-text
                                  label="Horas de Trabajo"
                                  decimal
                                  v-model="filterParDis.DscHourQuantity"
                              ></s-text>
                          </v-col>
                      </v-row>
                  </v-container>
              </template>
              <template v-slot="props">
                  <v-container>
                      <v-row >
                          <v-col class="s-col-form" sm="3" md="3">
                              <s-text                                
                                  label="Horas de Trabajo*" 
                                  decimal
                                  v-model="props.item.DscHourQuantity"/>
                                  
                          </v-col>
                          <v-col class="s-col-form" sm="3" md="3">
                              <s-date
                                  label="Fecha de Inicio*" 
                                  v-model="props.item.DscBeginDate"/>
                          </v-col> 
                      </v-row>
                  </v-container>
              </template>
              <template v-slot:SecStatus="{ row }">
                  <v-chip 
                      x-small 
                      black
                      :color="row.SecStatus == 1 ? 'success' : 'default'"
                  >
                      {{ row.SecStatus == 1 ?  "Activo" : "Inactivo" }}
                  </v-chip>
              </template>
          </s-crud>
        </v-col>
        <v-col lg="7">
          <s-crud title="Trabajadores con Parametros de Distribucion" 
            :config="configParDisWor" 
            @save="saveDetail($event)" 
            ref="gridWorkerPermit" 
            :itemsPerPage = "[10, 50, 100, 200, -1]" 
            :selectItemsPerPage="10"
            :filter="filterParDisWor"           
            remove > 
            <template v-slot:filter>
                <v-container>
                    <v-row>                        
                        <v-col>
                             <s-select-area
                              label="Areaaa"
                              v-model="filterParDisWor.AreID"                                                 
                            ></s-select-area>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:options>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" small elevation="0" @click="dialogOpern()" v-if="$fun.isAdmin()">                      
                      <v-icon style="font-size:18px;">mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span>Asignar Trabajadores</span>
              </v-tooltip>
              
            </template>
          </s-crud>
          <v-dialog v-model="showDialogAdd" max-width="1200" v-if="dialogOpen"  persistent>
            <v-card>
              <v-card-title>
                <label>Seleccione a los trabajadores que se les agregará los parámetros de distribución <strong>{{(selectedDC.DscHourQuantity || "")}} </strong> horas , 
                  con fecha de Inicio <strong>{{($fun.formatDateView(selectedDC.DscBeginDate) || "")}}  </strong></label>
              </v-card-title>              
              <v-card-text>
                <v-row>
                  <v-col lg="6">
                    <!-- <s-crud title="Trabajadores Sin Parámetros de Distribución" 
                      :config="configDisContWor"                     
                      ref="gridWorker" 
                      :itemsPerPage = "[10, 50, 100, 200, -1]" 
                      :selectItemsPerPage="10"
                      :filter="filterDisContWor"
                      :singleRow="false"
                      @rowSelected="addWorker($event)"             
                      remove > 
                      <template v-slot:filter>
                          <v-container>
                              <v-row>                        
                                  <v-col>
                                      <s-select-area
                                        label="Area"
                                        v-model="filterDisContWor.AreID"                                                 
                                      ></s-select-area>
                                  </v-col>
                              </v-row>
                          </v-container>
                      </template>
                      <template v-slot:options>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" small elevation="0" @click="copyAllow()" v-if="$fun.isAdmin()">
                                <v-icon color="default" x-small>
                                    fas fa-plus-circle
                                </v-icon>
                                <v-icon style="font-size:18px;">mdi-plus-circle-outline</v-icon>
                              </v-btn>
                          </template>
                          <span>Asignar Trabajadores</span>
                        </v-tooltip>
                        
                      </template>
                    </s-crud> -->
                    <s-toolbar
                      class="tran"
                      label="Trabajadores Sin Parámetros de Distribución"
                      
                      :search="false"
                     
                      color="black" 
                      dark            
                    >                      
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" small elevation="0" @click="copyAllow()" v-if="$fun.isAdmin()">
                              <!-- <v-icon color="default" x-small>
                                  fas fa-plus-circle
                              </v-icon> -->
                              <v-icon style="font-size:18px;">mdi-plus-circle-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Asignar Trabajadores</span>
                      </v-tooltip>
                      
                    </s-toolbar>
                    
                     <v-container>
                              <v-row>                        
                                  <v-col>
                                      <s-select-area
                                        label="Area"
                                        v-model="filterDisContWor.AreID"                                                                                         
                                      ></s-select-area>
                                  </v-col>
                              </v-row>
                          </v-container>
                    <v-card>
                      <v-data-table
                        dense
                        show-select
                        @click:row="rowClick"
                        selectable-key="isSelectable"
                        v-model="selected"
                        :headers="configDisContWor.headers"
                        item-key="PrsDocumentNumber"
                        :items="itemsWorkertActive"
                      ></v-data-table>
                    </v-card>
                  </v-col>
                  <v-col lg="6">
                    <s-toolbar
                      class="tran"
                      label="Asignación de Distribución a Trabajadores"
                      remove
                      :search="false"
                      @removed="removeEvent($event)"
                      color="black" 
                      dark            
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text v-on="on" small @click="removeAllWorkers()" elevation="0">
                            <v-icon style="font-size:18px;">mdi-delete-sweep</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar todos</span>
                      </v-tooltip>
                    </s-toolbar>
                    <v-card>
                      <v-data-table
                        dense
                        @click:row="rowClick"                        
                        single-select
                        show-select
                        v-model="selectedWorDisCon"
                        :headers="configPanel.headers"
                        item-key="PrsDocumentNumber"
                        :items="itemsWorkersDC"
                      ></v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn color="default " small text @click="closeDialogAdd()">
                  Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark depressed small @click="saveDistributionWorker()">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>          
        </v-col>
      </v-row>
  <!-- </v-card> -->
  </div>
</template>

<script>
  import _sDistributionControl from "@/services/HumanResource/HmnDistributionControlService.js";
  import _sWorketActiveDisCon from '@/services/HumanResource/HmnWorketActiveDisCon.js';
  import _sDistributionControlWorkert from '@/services/HumanResource/HmnDistributionControlWorkertService.js';

  export default {
    components: { },
    data() {
      return {
          filterParDis:{ 
            DscHourQuantity:0,           
          },
          configParDis: {
            service: _sDistributionControl,
            model: {
                DscID : "ID",               
                DscBeginDate: "date"
            },
            headers: [
                { text: "ID", value: "DscID" },
                { text: "Horas de Trabajo", value: "DscHourQuantity" },
                { text: "Fecha de Inicio", value: "DscBeginDate" },
                { text: "Estado", value: "SecStatus" }
            ]
          },
          selectedDC:[],
          filterParDisWor: { 
            AreID: null ,
            DscID : null,           
          },
          configParDisWor: {
            model: {
              DcwID: 'ID'
            },
            service: _sDistributionControlWorkert,
            headers: [
              { text: 'ID'                    , value: 'DcwID'              },
              { text: 'DNI'                   , value: 'PrsDocumentNumber'  },
              { text: 'Apellidos y Nombres'   , value: 'NtpFullName'        }, 
              { text: 'Área'                  , value: 'AreName'            },    
              { text: 'Horas de Trabajo'     , value: 'DscHourQuantity'    },          
            ],
          },
          selectedDCW:[],
          dialogOpen: false,
          showDialogAdd:{},
          selected:[],
          itemsCard: [],
          filterDisContWor:{ 
            AreID: null,
            search:""     
          },
          configDisContWor: {
            model: {
              WkrID: 'ID'
            },
            service: _sWorketActiveDisCon,
            headers: [
              { text: 'ID'                    , value: 'WkrID'              },
              { text: 'DNI'                   , value: 'PrsDocumentNumber'  },
              { text: 'Apellidos y Nombres'   , value: 'NtpFullName'        }, 
              { text: 'Área'                  , value: 'AreName'            },             
            ]
          },
          itemsWorkertActive:[],

          configPanel:{
            headers: [
              // { text: 'ID'                    , value: 'WkrID'              },
              { text: 'DNI'                   , value: 'PrsDocumentNumber'  },
              { text: 'Apellidos y Nombres'   , value: 'NtpFullName'        },
              { text: 'Área'                  , value: 'AreName'            },            
            ]
          },
          itemsWorkersDC:[],
          
          selectedWorDisCon:[]
      }
    },
    methods:{
      save(item){
        console.log(item);
        if(item.DscHourQuantity <= 0){
            this.$fun.alert("El campo Horas de Trabajo es Obligatorio","warning");
            return;
        }

        item.save();
      }, 
      copyAllow(){
        console.log("selectdc",this.selected);
        // this.itemsWorkersDC = this.selected;
        this.selected.forEach((element) => {
            console.log(element);
            if (this.itemsWorkersDC.find((x) => x.PrsDocumentNumber === element.PrsDocumentNumber) == null) {
              this.itemsWorkersDC.push(element);
              
              // const index = this.items.findIndex(
              //   (item) => item.PrsDocumentNumber === element.PrsDocumentNumber
              // );
              // if (index !== -1) {
              //   this.items.splice(index, 1);
              // }
            }
          });
          
          this.selectionBefore = [];
      },
      removeEvent(value) {
        if (this.selectedWorDisCon.length == 1) {
          // Guardar una referencia al elemento que se va a eliminar
          const itemToRemove = this.selectedWorDisCon[0];
          
          // Eliminar el elemento de itemsCard
          this.itemsWorkersDC = this.itemsWorkersDC.filter((x) => x != itemToRemove);
          
          // // Añadir el elemento a la lista principal (items)
          // this.items.push(itemToRemove);
          
          // Reordenar la lista principal por NtpFullName
          this.items.sort((a, b) => {
            if (a.NtpFullName < b.NtpFullName) return -1;
            if (a.NtpFullName > b.NtpFullName) return 1;
            return 0;
          });
          
          this.selected = [];
        }
      },
      removeAllWorkers(){
        this.itemsWorkersDC = [];
      },
      rowSelected(rows) {
        // metodo
        if (rows.length > 0) {
          this.selectedDC = rows[0];
          console.log("seleccionar",rows[0]);
          this.filterParDisWor.DscID = this.selectedDC.DscID;
        }
      },
      rowClick(){
        
      },
      addWorker(rows) {
        if (rows.length > 0) {
          this.selected = rows;
          
          console.log("wworker",rows);
        }
        
      },
      closeDialogAdd(){
        this.dialogOpen = false;
        this.itemsWorkertActive = [];
        this.itemsWorkersDC = [];
        this.filterDisContWor.AreID = null;

      },
      saveDistributionWorker(){
        console.log("Items Worket",this.itemsWorkertActive);
        this.itemsWorkertActive.forEach(x=>{
          x.DscID = this.selectedDC.DscID;
          x.UsrCreateID = this.$fun.getUserID();
        })
        console.log("Items Worket Actualizado",this.itemsWorkertActive);
        this.$fun.alert("¿Seguro de Guardar?", "question")
					.then(r => {
						if(r.value)
						{
              _sDistributionControlWorkert.saveMassive(this.itemsWorkertActive,this.$fun.getUserID()).then(resp => {
                if(resp.status == 200){
                  console.log("resp:",resp);
                  this.$fun.alert("Registrado Correctamente","success")
                }
              });
            }
          
          });

        
      },
      listWorkertActive(){
        _sDistributionControl.listWorketActive(this.filterDisContWor, this.$fun.getUserID()).then(resp => {
          if(resp.status == 200){
            console.log("resp:",resp);
            this.itemsWorkertActive = resp.data;
          }
        });
      },

      dialogOpern(){
        console.log("Abrir el Open")
        console.log("selectedDC",this.selectedDC);
        this.dialogOpen = true;
        this.listWorkertActive();
      },
    },
    watch:{
      'filterDisContWor.AreID'(){
          this.listWorkertActive();
      }
    }
  }
</script>
